import { reactive } from 'vue';

const state = reactive({
  modals: {},
  dialog: {
    visible: false,
    title: '',
    text: '',
    buttons: []
  }
});

function ensureModal (name) {
  if (!state.modals[name]) {
    state.modals[name] = {
      visible: false,
      payload: null
    };
  }
  return state.modals[name];
}

const modalApi = {
  state,
  show (name, payload) {
    if (name === 'dialog') {
      state.dialog.visible = true;
      state.dialog.title = payload && payload.title ? payload.title : '';
      state.dialog.text = payload && payload.text ? payload.text : '';
      state.dialog.buttons = payload && payload.buttons ? payload.buttons : [];
      return;
    }

    const modal = ensureModal(name);
    modal.payload = payload || null;
    modal.visible = true;
  },
  hide (name) {
    if (name === 'dialog') {
      state.dialog.visible = false;
      state.dialog.title = '';
      state.dialog.text = '';
      state.dialog.buttons = [];
      return;
    }

    const modal = ensureModal(name);
    modal.visible = false;
    modal.payload = null;
  },
  isVisible (name) {
    return !!(state.modals[name] && state.modals[name].visible);
  },
  getPayload (name) {
    return state.modals[name] ? state.modals[name].payload : null;
  }
};

export function getModalApi () {
  return modalApi;
}

export default {
  install (app) {
    app.config.globalProperties.$modal = modalApi;
    app.$modal = modalApi;
  }
};
